























import { Component, Vue } from 'vue-property-decorator';
import { getUserList, removeUser } from '@/api/users';
import { accountModule } from '@/store/modules/account';
import { IUser } from '@/api/types';

@Component({})
export default class AccountList extends Vue {
  private listLoading: boolean = true;

  private async created() {
    await accountModule.fetchUserList();
    this.listLoading = false;
  }

  get users() {
    return accountModule.userList;
  }

  edit(id: string) {
    this.$router.push(`edit/${id}`);
  }

  private async remove(index) {
    try {
      await this.$confirm('此操作将永久删除该数据，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      const id = this.users[index]._id;
      await accountModule.removeUser(id);
      this.$message.success('删除成功');
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error(error.message);
      }
    }
  }
}
